





















import { Component, Vue } from "vue-property-decorator";
import OutpatientWaitingList from "@/components/outpatient-waiting/OutpatientWaitingList.vue";
import OutpatientWaitingDashboard from "@/components/outpatient-waiting/OutpatientWaitingDashboard.vue";
import OutpatientWaitingMonthlyReport from "@/components/outpatient-waiting/OutpatientWaitingMonthlyReport.vue";

@Component({
  components: { OutpatientWaitingList, OutpatientWaitingDashboard, OutpatientWaitingMonthlyReport }
})
export default class OutpatientWaitingPage extends Vue {
  tab = 0;
}
